import { UrgentFollowUpTabs } from '@pages/urgentfollowups/types';
import { VirtualAgentFilters } from '../hooks/useVirtualAgentFilters';
import { FollowUpStatus, VaFollowUpFilterInput } from '@api/generated/graphql';
import { oneDayInMS } from '@pages/urgentfollowups/utils/filters';

const openFollowUpStatuses = [
  FollowUpStatus.New,
  FollowUpStatus.FollowUpNeeded,
  FollowUpStatus.ContactAttempted,
];

const coldFollowUpStatuses = [...openFollowUpStatuses];

export const doneFollowUpStatuses = [
  FollowUpStatus.Dismissed,
  FollowUpStatus.Resolved,
];

export const getStatusFilters = (tab: UrgentFollowUpTabs): FollowUpStatus[] => {
  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return openFollowUpStatuses;
    case UrgentFollowUpTabs.Cold:
      return coldFollowUpStatuses;
    case UrgentFollowUpTabs.Done:
      return doneFollowUpStatuses;
  }
};

const getOpenVirtualAgentFilters = (): Partial<VirtualAgentFilters> => {
  return {
    fromDate: new Date(new Date().getTime() - oneDayInMS),
  };
};

const getColdVirtualAgentFilters = (): Partial<VirtualAgentFilters> => {
  return {
    toDate: new Date(new Date().getTime() - oneDayInMS),
  };
};

const getDoneVirtualAgentFilters = (): Partial<VirtualAgentFilters> => {
  return {};
};

export const getDefaultVirtualAgentFilters = (
  tab: UrgentFollowUpTabs,
): VirtualAgentFilters => {
  const statuses = getStatusFilters(tab);
  const filter: VirtualAgentFilters = {
    statuses,
    includeNullCallReasons: false,
    includeNullCallTypes: false,
    includeNullCampaigns: false,
    includeNullAssignedTo: false,
  };

  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return { ...filter, ...getOpenVirtualAgentFilters() };
    case UrgentFollowUpTabs.Cold:
      return { ...filter, ...getColdVirtualAgentFilters() };
    case UrgentFollowUpTabs.Done:
      return { ...filter, ...getDoneVirtualAgentFilters() };
  }
};

export const getVirtualAgentFollowUpsBadgeCountFilters =
  (): VaFollowUpFilterInput => {
    // If we don't floor to the nearest minute, the query perpetually
    // re-triggers, presumably due to the date's exact value changing on every
    // re-render.
    const fromDate = getOpenVirtualAgentFilters().fromDate;

    fromDate?.setMilliseconds(0);
    fromDate?.setSeconds(0);

    return {
      fromDate,
      // For the badge count we want *new* open followups.
      followUpStatuses: [FollowUpStatus.New],
    };
  };
